//* ============================ UTILS ============================
// Must match the corresponding GlCodeUtils.GlCodeType names in commons — these are the
// only "parent" classic GL codes a custom GL code can be restricted to from the UI, each
// unlocking a different downstream use: Additional Fees configuration, GL Code Assignment
// (FC2-4160/4167, which the backend enforces on create/update), or — for
// ADDITIONAL_FEE_AS_PURCHASE_FEE — an additional fee that reports as Purchasing Fee.
export const ADDITIONAL_FEE_PARENT_GL_CODE_TYPE = 'additionalFees'
export const PAYMENT_TRANSACTION_PARENT_GL_CODE_TYPE = 'assignPaymentToInvoice'
export const ADDITIONAL_FEE_AS_PURCHASE_FEE_PARENT_GL_CODE_TYPE = 'purchaseFee'
export const FUND_INVOICE_GROUPS_PARENT_GL_CODE_TYPE = 'fundInvoiceGroups'
export const RETURNED_PAYMENT_PARENT_GL_CODE_TYPE = 'returnedPayment'

//* ============================ INFOS ============================
export type CustomGlCodeInfo = {
  id: string
  code: string
  name: string
  description?: string
  hasLedgerEntries: boolean
  parentGlCodeType?: string
}

export type CustomGlCodeUsageInfo = {
  connectedToInboundAccount: boolean
  connectedToOutboundAccount: boolean
  connectedToReturnedAccount: boolean
  inUse: boolean
}

//* ============================ RESPONSES ========================
export type CustomGlCodeSingletonResponse = {
  customGlCode: CustomGlCodeInfo
}

export type CustomGlCodesResponse = {
  customGlCodes: CustomGlCodeInfo[]
}

export type CustomGlCodeUsageResponse = {
  usage: CustomGlCodeUsageInfo
}

//* ============================ REQUESTS =========================
export type CreateCustomGlCodeRequest = {
  code: string
  name: string
  description?: string
  parentGlCodeType?: string
}

// The code is immutable after creation (backend rejects any change), so it's intentionally
// not part of this type — nothing to send, nothing to show as editable.
export type UpdateCustomGlCodeRequest = {
  name: string
  description?: string
  parentGlCodeType?: string
}

export type ListCustomGlCodesParams = {
  q?: string
  sort?: string
}
